// extracted by mini-css-extract-plugin
export var truncate = "_n-0";